import { render, staticRenderFns } from "./StatView.vue?vue&type=template&id=566b9b52&scoped=true"
import script from "./StatView.vue?vue&type=script&lang=js"
export * from "./StatView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b9b52",
  null
  
)

export default component.exports